import { render, staticRenderFns } from "./AdminResetPassword.vue?vue&type=template&id=6e4e66ee&scoped=true&"
import script from "./AdminResetPassword.vue?vue&type=script&lang=js&"
export * from "./AdminResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./AdminResetPassword.vue?vue&type=style&index=0&id=6e4e66ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e66ee",
  null
  
)

export default component.exports